// extracted by mini-css-extract-plugin
export default {"Phone__phone":"phone_Phone__phone__A7juR","Phone__whatsapp":"phone_Phone__whatsapp__iPXpk","Phone__whatsapp__link":"phone_Phone__whatsapp__link__5j9+j","Phone":"phone_Phone__bv6fg"};